module.exports = __webpack_public_path__ + "static/media/thankyousvg.8cf35315.svg";